"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mapper = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var date_fns_1 = require("date-fns");
var Text_1 = __importDefault(require("shared/components/Text"));
var hooks_1 = require("utils/hooks");
var CloseNotification_1 = __importDefault(require("../styles/CloseNotification"));
var NotificationDiv_1 = __importDefault(require("../styles/NotificationDiv"));
var NotificationTime_1 = __importDefault(require("../styles/NotificationTime"));
var CommentAdded_1 = __importDefault(require("./CommentAdded"));
var CommentMention_1 = __importDefault(require("./CommentMention"));
var ConnectAccounting_1 = __importDefault(require("./ConnectAccounting"));
var ConnectionActivated_1 = __importDefault(require("./ConnectionActivated"));
var ConnectionDeactivated_1 = __importDefault(require("./ConnectionDeactivated"));
var FetchTransactions_1 = __importDefault(require("./FetchTransactions"));
var InsightAvailable_1 = __importDefault(require("./InsightAvailable"));
var NewService_1 = __importDefault(require("./NewService"));
var OwnerAssign_1 = __importDefault(require("./OwnerAssign"));
var CustomerArchived_1 = __importDefault(require("./Rechargly/CustomerArchived"));
var RecoActioned_1 = __importDefault(require("./RecoActioned"));
var RenewalUpcoming_1 = __importDefault(require("./RenewalUpcoming"));
var ScanServices_1 = __importDefault(require("./ScanServices"));
// export const Mapper: Record<NotifType, NotificationComponent> = {
exports.Mapper = {
    CONNECTION_ACTIVATED: ConnectionActivated_1.default,
    CONNECTION_DEACTIVATED: ConnectionDeactivated_1.default,
    RECH_ARCHIVED_CONTACT: CustomerArchived_1.default,
    NEW_SERVICE: NewService_1.default,
    OWNER_ASSIGN: OwnerAssign_1.default,
    COMMENT_MENTION: CommentMention_1.default,
    COMMENT_ADDED: CommentAdded_1.default,
    RENEWAL_UPCOMING: RenewalUpcoming_1.default,
    GLOBAL_CONNECT_ACCOUNTING: ConnectAccounting_1.default,
    GLOBAL_FETCH_TRANSACTIONS: FetchTransactions_1.default,
    GLOBAL_SCANNING: ScanServices_1.default,
    RECO_ACTIONED: RecoActioned_1.default,
    INSIGHT_AVAILABLE: InsightAvailable_1.default,
};
var NotificationFactory = function (_a) {
    var _b;
    var notifications = _a.notifications, type = _a.type;
    var Component = exports.Mapper[type];
    var _c = __read((0, hooks_1.useBatchSubmitter)('notifications', notifications.map(function (_a) {
        var id = _a.id;
        return id;
    }), {
        show: false, reasonForHide: 'User Closed',
    }), 2), hideNotifications = _c[0], isSending = _c[1];
    if (!Component) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(NotificationDiv_1.default, { children: [(0, jsx_runtime_1.jsx)(Box_1.default, __assign({ display: "flex", justifyContent: "flex-end" }, { children: (0, jsx_runtime_1.jsx)(CloseNotification_1.default, __assign({ onClick: function () { return hideNotifications({}, "hiding-notif-".concat(type)); }, type: "button", disabled: isSending }, { children: "close" })) })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 2 }, { children: (0, jsx_runtime_1.jsx)(Component, { notifications: notifications }) })), (0, jsx_runtime_1.jsx)(NotificationTime_1.default, { children: notifications[0].updatedAt && (0, date_fns_1.format)((_b = notifications[0].updatedAt) === null || _b === void 0 ? void 0 : _b.toDate(), 'MMM dd, yyyy') })] }));
};
exports.default = NotificationFactory;
